var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.73976V19.4995C0.00360547 22.4896 2.42663 24.9126 5.41668 24.9162H20.5834C23.5734 24.9126 25.9964 22.4896 26 19.4995V9.61951L0 9.73976Z",
    fill: "#FFC300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5833 3.25001H13.5113C13.3438 3.25112 13.1782 3.21405 13.0271 3.14169L9.60807 1.42569C9.15672 1.20093 8.65952 1.08378 8.15532 1.08337H5.41663C2.42663 1.08693 0.00360547 3.50996 0 6.50001V7.57357L25.8516 7.45332C25.2871 4.99729 23.1034 3.25503 20.5833 3.25001Z",
    fill: "#FFC300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderYellow);
export default __webpack_public_path__ + "static/media/folder_yellow.cf9473145e6d04f450dcc2a128d9c7e2.svg";
export { ForwardRef as ReactComponent };